import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { IPatchOperation } from "../../../utils/interfaces";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";
import { auxiliarData } from "../AuxiliarData";

interface IProps {
  slotId: string;
  status?: "free" | "busy-unavailable" | "busy";
}

export async function PatchSlot({ slotId, status }: IProps) {
  const url = `${endpoints.WORKFLOWFHIR}/Slot/${slotId}`;

  let operations: IPatchOperation[] = [];
  if (status)
    operations.push({
      op: "replace",
      path: "/status",
      value: status,
    });
  const data = auxiliarData.Patch({
    operations,
  });

  const headers = {
    Accept: "application/json-patch+json",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/json-patch+json",
  };

  const response = await useAxios
    .patch(url, data, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`PatchSlot: ${response.status}`);
      }
      return { data: response.data, status: response.status };
    })
    .catch((error) => {
      console.error("PatchSlot ", error);
      // toast.error(`PatchSlot Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
